import React, { useRef, useEffect, MouseEvent } from 'react';

type CitationRemovalPaneProps = {
  onDelete: (reason: string) => void,
  onCancel: () => void
}

const CitationRemovalPane: React.FC<CitationRemovalPaneProps> = ({ onDelete, onCancel }) => {
  const ref = useRef<HTMLDivElement>(null);

  const deleteCommonPhrase = (e: MouseEvent): void => {
    e.stopPropagation();
    onDelete('common_phrase');
  };

  const deleteWithUnspecifiedReason = (e: MouseEvent) => {
    e.stopPropagation();
    onDelete('unspecified');
  };

  useEffect((): (() => void) => {
    const handleClickOutside = (event) => {
      if (!ref.current.contains(event.target)) {
        onCancel();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="overlay RemovalPane d-flex justify-content-center CitationRemovalPane" ref={ref}>
      <div className="d-flex justify-content-around align-items-center CitationRemovalPane-controls">
        <button
          type="button"
          onClick={deleteCommonPhrase}
          className="btn btn-white-outline"
          onMouseDown={(e) => e.preventDefault()}
        >
          Common Phrase
        </button>
        <div className="CitationRemovalPane-separator" />
        <button
          type="button"
          className="btn btn-danger"
          onClick={deleteWithUnspecifiedReason}
          onMouseDown={(e) => e.preventDefault()}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default CitationRemovalPane;
